(function() {
    'use strict';

    a3_cabin_reports.controller('BucketModalCtrl', BucketModalCtrl)
    /**
     * @memberof CabinReports
     * @ngdoc controller
     * @name BucketModalCtrl
     * @description 
     * Shows Share/Unshare Modal 
     * @ngInject
     */

    function BucketModalCtrl($scope, $timeout, $uibModalInstance, duty, currentDutyId, BucketFactory){
        $scope.duty = duty;
        $scope.currentDutyId = currentDutyId;
        $scope.closeDuty = closeDuty;

        $scope.shareDuty = shareDuty;
        $scope.responseText = null;
        $scope.responseHasErrors = null;

        $scope.submitted = false;

        /**
         * Close the modal
         * @memberof BucketModalCtrl
         */
        function closeDuty(refresh){
            $uibModalInstance.close(refresh);
        }

        /**
         * Adds/Removes duty to/from global bucket
         * @memberof BucketModalCtrl
         */
        function shareDuty() {
            $scope.submitted = true;
           
            duty.Comments = $scope.duty.Comments;

            BucketFactory.shareDuty(duty, function (responseData) {
                displayMessage("Duty shared.",false);
                $timeout(function () {closeDuty(true);} , 5000);
            },
            function (){
                displayMessage("Failed to share duty.",true);
            }
            );
        }

        /**
         * Displays message when share/unshare 
         * @memberof BucketModalCtrl
         * @param {string} message 
         * @param {boolean} hasErrors 
         */
        function displayMessage(message, hasErrors) {
            $scope.responseText = message;
            $scope.responseHasErrors = hasErrors;
        }
    }
})();